import script from "./DownloadPostel.vue?vue&type=script&setup=true&lang=js"
export * from "./DownloadPostel.vue?vue&type=script&setup=true&lang=js"

import "./DownloadPostel.vue?vue&type=style&index=0&id=884368ea&lang=css"

const __exports__ = script;

export default __exports__